interface TranscriptBootstrapState<Entry> {
  sessionId: string | null;
  entries: Entry[];
  totalEntries: number;
  oldestTs: number | null;
  newestTs: number | null;
  projectionVersion: number;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export function beginTranscriptBootstrapRefresh<Entry>(
  current: TranscriptBootstrapState<Entry>,
  sessionId: string,
  projectionVersion: number,
): TranscriptBootstrapState<Entry> {
  if (current.sessionId === sessionId && current.loaded) {
    return { ...current, projectionVersion, error: null };
  }
  return {
    sessionId,
    entries: [],
    totalEntries: 0,
    oldestTs: null,
    newestTs: null,
    projectionVersion,
    loading: true,
    loaded: false,
    error: null,
  };
}
